import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './InfoLabel.scss';

export default class InfoLabel extends PureComponent {
	render() {
		const { contactName, isPrepay } = this.props;

		return (
			<div className="info-label flex flex-align-items-center padding-20 margin-bottom-30">
				<div className="margin-right-30">
					<i className="rkf rkf-invoice font-size-40 color-yellow-golden-tainoi" />
				</div>
				<div>
					<div>
						You have received a pending estimate from
						<b>{` ${contactName}`}</b>
						.
					</div>
					<div>{`${isPrepay ? 'Prepayment' : 'Your approval'} is required in order for the job to be started`}</div>
				</div>
			</div>
		);
	}
}

InfoLabel.propTypes = {
	contactName : PropTypes.string,
	isPrepay    : PropTypes.bool,
};

InfoLabel.defaultProps = {
	contactName : '',
	isPrepay    : false,
};
